import { FaFacebookF, FaTwitter, FaInstagram, FaTiktok } from 'react-icons/fa'

import Empty from '../../components/empty/Empty'
import Social from '../../components/buttons/Social'
import './pages.css'

const Home = ({isCurrent, data, title, social}) => {

      if(isCurrent !== 'home') return 

      if(data.data){
            return (
                  <div className={isCurrent === 'home' ? "content_page show" : "content_page"}>
                        <Empty text={`Not Found Data`}/>
                  </div>
            )
      }

      return (
            <div className={isCurrent === 'home' ? "content_page show" : "content_page"}>
                  <h1>{title}</h1>
                  <div className="home_description">
                        <p>{data.about}</p>
                  </div>
                  <div className="wrapper_social">
                        <h3>Social Networks</h3>
                        <div className="social_menu">
                              <Social link={social.facebook === '' ? "https://www.facebook.com" : social.facebook} icon={<FaFacebookF />}/>
                              <Social link={social.twitter === '' ? "https://www.twitter.com" : social.twitter} icon={<FaTwitter />}/>
                              <Social link={social.instagram === '' ? "https://www.instagram.com" : social.instagram} icon={<FaInstagram />}/>
                              <Social link={social.tiktok === '' ? "https://www.tiktok.com" : social.tiktok} icon={<FaTiktok />}/>
                        </div>
                  </div>
            </div>
      )

}

export default Home
